export default __webpack_public_path__ + "static/media/fav.de82f684.svg";